import Grid from "@mui/material/Grid";
import ErrorAlert from "./ErrorAlert";
import CustomButton from "../../../../shared/ui/CustomButton";
import Box from "@mui/material/Box";
import React from "react";

type Props = {
    errorMessage: string;
    hasSteps?: boolean;
    step?: number;
    totalSteps?: number;
    itemsLength?: number;
    confirmPreviousStep?: () => void;
    // children: JSX.Element[] | JSX.Element;
};

const AddTestButton = ({errorMessage, hasSteps = false, step, totalSteps, itemsLength, confirmPreviousStep}: Props) => {
    const isNextDisabled = (step === 2 && itemsLength === 0) || (step === 3 && itemsLength === 0);

    const nextButtonLabel = step === totalSteps ? "Generează test" : "Pasul urmator";

    return (
        <Grid
            width="100%"
            sx={{position: "fixed", bottom: 0, left: 0, zIndex: 999}}
            container
            direction="row"
            justifyContent="flex-start"
        >
            <Grid
                item
                xs={12}
                lg={3}
                xl={3}
                sx={{
                    paddingRight: {xs: 0, md: "10px",},
                    backgroundColor: "background.default"
                }}
            ></Grid>
            <Grid
                item
                xs={12}
                lg={9}
                xl={9}
                pt={2}
                pb={2}
                pl={{xs: 2, md: 4}}
                pr={{xs: 2, md: 4}}
                sx={{backgroundColor: "background.default"}}
            >
                {hasSteps ? (
                    <Box display="flex" justifyContent="space-between">
                        <CustomButton
                            buttonType="textIcon" disabled={step === 1}
                            onClick={confirmPreviousStep}
                            sx={{whiteSpace: "nowrap"}}
                        >
                            Pasul anterior
                        </CustomButton>
                        <Box display="flex" justifyContent="end">
                        {errorMessage && <ErrorAlert message={errorMessage} />}
                        <CustomButton
                            disabled={isNextDisabled}
                            buttonType="textIcon"
                            type="submit"
                            sx={{whiteSpace: "nowrap"}}
                        >
                            {nextButtonLabel}
                        </CustomButton>
                        </Box>
                    </Box>
                ) : (
                    <Box display="flex" justifyContent="end">
                        {errorMessage && <ErrorAlert message={errorMessage} />}
                        <CustomButton
                            buttonType="textIcon"
                            type="submit"
                            sx={{whiteSpace: "nowrap"}}
                        >
                            Generează test
                        </CustomButton>
                    </Box>
                )}
            </Grid>
        </Grid>
    );
};

export default AddTestButton;
